import { fromJS } from 'immutable';
import { normalizeEntities } from 'helpers/utilHelpers';

import {
  LOAD_TASK_BY_ID_SUCCESS,
  UPDATE_TASK_SUCCESS,
  LOAD_PROJECT_BY_ID_SUCCESS,
  LOAD_PROJECTS_SUCCESS,
  UPDATE_PROJECT_SUCCESS,
  LOAD_PROJECT_FILE_LIST_SUCCESS,
  UPLOAD_ENTITY_FILE_SUCCESS,
  DELETE_FILE_SUCCESS,
  LOAD_TASK_ACTIVITY_LOG_SUCCESS,
  CREATE_COMMENT_SUCCESS,
  UPDATE_COMMENT_SUCCESS,
  LOAD_PROJECTS_FAVORITE_MAP_SUCCESS,
  LOAD_ARTICLE_BY_ID_SUCCESS,
  LOAD_ARTICLES_SUCCESS,
  UPDATE_ARTICLE_SUCCESS,
  APPEND_ACTIVITY_LOG,
  LOAD_TASK_COMMENTS_SUCCESS,
} from 'constants/ActionTypes';

const initialState = fromJS({
  files: {},
});

const prepareFiles = (entity) => {
  const files = [];
  if (!entity.files?.length || !files) {
    return files;
  }

  if (files) {
    entity.files.forEach((file) => {
      files.push(file);
    });
  }

  return files;
};

const fileReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_TASK_SUCCESS:
    case LOAD_TASK_BY_ID_SUCCESS: {
      return state.set('files', normalizeEntities(prepareFiles(action.task), 'fileId', state.get('files')));
    }
    case UPDATE_PROJECT_SUCCESS:
    case LOAD_PROJECT_BY_ID_SUCCESS: {
      return state.set('files', normalizeEntities(prepareFiles(action.project), 'fileId', state.get('files')));
    }
    case LOAD_PROJECT_FILE_LIST_SUCCESS: {
      return state.set('files', normalizeEntities(action.fileList.items, 'fileId', state.get('files')));
    }
    case UPLOAD_ENTITY_FILE_SUCCESS: {
      if (action.response.file) {
        return state.setIn(
          ['files', action.response.file.fileId],
          fromJS(action.response.file).merge({ entityInfo: action.response.entityInfo }),
        );
      }
      return state;
    }
    case DELETE_FILE_SUCCESS:
      return state.deleteIn(['files', action.fileId]);
    case LOAD_TASK_ACTIVITY_LOG_SUCCESS: {
      const files = action.logs.items.map((log) => prepareFiles({ ...log.comment }));
      return state.set('files', normalizeEntities(files.flat(), 'fileId', state.get('files')));
    }
    case APPEND_ACTIVITY_LOG: {
      if (!action.payload.comment?.files?.length) {
        return state;
      }

      return state.set('files', normalizeEntities(prepareFiles(action.payload.comment), 'fileId', state.get('files')));
    }
    case LOAD_TASK_COMMENTS_SUCCESS: {
      const files = action.payload.items.map((comment) => prepareFiles({ ...comment }));
      return state.set('files', normalizeEntities(files.flat(), 'fileId', state.get('files')));
    }
    case CREATE_COMMENT_SUCCESS: {
      return state.set('files', normalizeEntities(prepareFiles(action.values), 'fileId', state.get('files')));
    }
    case UPDATE_COMMENT_SUCCESS: {
      return state.set('files', normalizeEntities(prepareFiles(action.comment), 'fileId', state.get('files')));
    }
    case LOAD_PROJECTS_FAVORITE_MAP_SUCCESS: {
      const files = action.projectsFavoriteMap.items.map((item) => prepareFiles({ ...item.relatedEntity }));
      return state.set('files', normalizeEntities(files.flat(), 'fileId', state.get('files')));
    }
    case LOAD_ARTICLE_BY_ID_SUCCESS: {
      return state.set('files', normalizeEntities(prepareFiles(action.article), 'fileId', state.get('files')));
    }
    case LOAD_ARTICLES_SUCCESS: {
      const files = action.articles.items.map((item) => prepareFiles({ ...item }));
      return state.set('files', normalizeEntities(files.flat(), 'fileId', state.get('files')));
    }
    case UPDATE_ARTICLE_SUCCESS: {
      return state.set('files', normalizeEntities(prepareFiles(action.article), 'fileId', state.get('files')));
    }
    case LOAD_PROJECTS_SUCCESS: {
      const files = [];
      action.projects.items.forEach((project) => {
        files.push(...prepareFiles(project));
      });
      return state.set('files', normalizeEntities(files, 'fileId', state.get('files')));
    }
    default:
      return state;
  }
};

export default fileReducer;
